import { Button, Card, IconButton, Stack, TextField, Typography } from '@mui/material';
import { CommentFragment } from '../generated/graphql';
import { useApp } from './app-context';

import React from 'react';
import { EditIcon, RemoveItemIcon } from './icons';

interface CommentCardProps {
  comment: CommentFragment;
  onDelete: (comment: CommentFragment) => void;
  onEdit: (commentId: string, comment: string) => void;
  disabled?: boolean;
  menuItems?: {
    label: string;
    onClick: () => void;
  }[];
}
export const CommentCard = ({ comment, onDelete, onEdit, disabled }: CommentCardProps) => {
  const app = useApp();
  const [isEditing, setIsEditing] = React.useState(false);
  const [noteText, setNoteText] = React.useState(comment.comment);

  const handleKeyPress = React.useCallback((event: React.KeyboardEvent<HTMLDivElement>) => {
    // if (event.code === 'Enter') {
    //   if (onEdit) {
    //     onEdit(note.id, noteText);
    //   }
    //   setIsEditing(false);
    // }
    if (event.code === 'Escape') {
      setIsEditing(false);
    }
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNoteText(event.target.value);
  };

  return (
    <Card variant="outlined" sx={{ width: '100%', padding: 1 }}>
      <Stack direction="row" width="100%" alignItems="center">
        <Stack direction="row" spacing={2}>
          <Typography variant="body2">{app.formatDateTime(comment.createdAt)}</Typography>
          <Typography variant="body2">{comment.creator?.email}</Typography>
        </Stack>
        {/* actions allowed for non-system notes only */}
        {comment.createdBy && (
          <Stack direction="row" spacing={0} sx={{ marginLeft: 'auto' }}>
            <IconButton onClick={() => setIsEditing(true)} size="small" disabled={disabled}>
              <EditIcon />
            </IconButton>

            <IconButton onClick={() => onDelete(comment)} size="small" disabled={disabled}>
              <RemoveItemIcon />
            </IconButton>
          </Stack>
        )}
      </Stack>

      {!isEditing && (
        <Typography variant="body1" color="text.secondary">
          {comment.comment}
        </Typography>
      )}
      {isEditing && (
        <Stack spacing={2} sx={{ width: '100%' }}>
          <TextField
            value={noteText}
            onChange={handleChange}
            onKeyUp={handleKeyPress}
            multiline
            fullWidth
            maxRows={4}
          />
          <Stack direction="row" spacing={2} sx={{ marginTop: 2, justifyContent: 'end' }}>
            <Button size="small" onClick={() => setIsEditing(false)}>
              Zatvoriť
            </Button>
            <Button
              size="small"
              onClick={() => {
                setIsEditing(false);
                onEdit(comment.id, noteText);
              }}
              variant="contained"
            >
              Uložiť
            </Button>
          </Stack>
        </Stack>
      )}
    </Card>
  );
};
